import { useCustomTranslation } from '../../../localization/hooks/useCustomTranslation';
import { moduleId } from '../config';

export const useFeedbackTranslation = (keyPrefix: string) =>
  useCustomTranslation({ moduleId, keyPrefix });
